enum Destination {
  NONE = '',
  // NONE = '-1',
  AUA = 'AUA', // Oranjestad, Aruba
  CHI = 'CHI', // Chicago, IL
  CUN = 'CUN', // Cancun, Quintana Roo, Mexico
  FLL = 'FLL', // Fort Lauderdale, FL
  HNL = 'HNL', // Honolulu, HI
  LAS = 'LAS', // Las Vegas, NV
  LAX = 'LAX', // Los Angeles, CA (LAX-Los Angeles Intl.)
  LON = 'LON', // London, England, UK
  MBJ = 'MBJ', // Montego Bay, Jamaica
  MCO = 'MCO', // Orlando, FL
  MIA = 'MIA', // Miami, FL
  MSY = 'MSY', // New Orleans, LA
  NAS = 'NAS', // Nassau, Bahamas
  NYC = 'NYC', // New York, NY
  OGG = 'OGG', // Kahului, HI
  ORL = 'ORL', // Orlando, FL
  PAR = 'PAR', // Paris, France
  PHX = 'PHX', // Phoenix, AZ
  PUJ = 'PUJ', // Punta Cana, Dominican Republic
  PVR = 'PVR', // Puerto Vallarta, Jalisco, Mexico
  QLA = 'QLA', // Los Angeles, CA (QLA-All Airports)
  QSF = 'QSF', // San Francisco, CA
  ROM = 'ROM', // Rome, Italy
  SAN = 'SAN', // San Diego, CA
  SJD = 'SJD', // San Jose del Cabo, Baja California Sur, Mexico
  SJU = 'SJU', // San Juan, Puerto Rico
}

export { Destination };
